import { motion, useInView } from 'motion/react';
import { PropsWithChildren, useRef } from 'react';
import styled from 'styled-components';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionPrivateDistributionProps extends PropsWithChildren {
  className?: string;
}

export const MotionPrivateDistribution = ({
  children,
  className,
}: MotionPrivateDistributionProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: ANIMATION_CONFIG.store.amount,
  });

  return (
    <MotionPrivateDistributionWrapper
      className={className}
      ref={ref}
      initial={{ opacity: 0, scale: ANIMATION_CONFIG.store.scale }}
      animate={
        isInView
          ? { opacity: 1, scale: 1 }
          : { opacity: 0, scale: ANIMATION_CONFIG.store.scale }
      }
      transition={{
        duration: ANIMATION_CONFIG.store.duration,
      }}
    >
      {children}
    </MotionPrivateDistributionWrapper>
  );
};

const MotionPrivateDistributionWrapper = styled(motion.div)``;
